import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";

const defaultBulkStageUpdateObj = {
  accountCount: 0,
  accountIds: [],
  allAccountsSelectedInView: false,
  searchFilter: {}
};

class AccountBulkActionsState {
  @observable showBulkUpdateStagePopup = false;
  @observable bulkStageUpdateObj = { ...defaultBulkStageUpdateObj };

  @action
  setShowBulkUpdateStagePopup = (val = false) => {
    this.showBulkUpdateStagePopup = val;
  };

  @action
  setBulkStageUpdateObj = (obj = {}) => {
    this.bulkStageUpdateObj = obj;
  };

  @action
  resetBulkStageUpdateObj = () => {
    this.bulkStageUpdateObj = { ...defaultBulkStageUpdateObj };
  };

  @action
  bulkStageChange = async (
    accountStageId = "",
    accountIds = [],
    totalCount = 0,
    allAccountsSelectedInView = false,
    searchFilter = {}
  ) => {
    const config = {
      url: URLS.performBulkAccountOperation,
      method: "POST",
      data: {
        type: "ACCOUNT_STAGE_UPDATE",
        totalCount,
        filter: {
          // "select all" has no explicit accountIds - scope it to whatever filter (stage
          // tab, list, search, advanced fields) the Accounts list currently has applied,
          // the same payload used to fetch the list itself. Without this, "select all"
          // would resolve to every account the team has, ignoring the current view.
          ...(allAccountsSelectedInView
            ? { accountPayload: searchFilter }
            : { accountIds })
        },
        data: {
          accountStageId
        }
      }
    };
    return await makeApi(config);
  };

  @action
  deleteAccounts = async (
    accountIds = [],
    totalCount = 0,
    allAccountsSelectedInView = false,
    searchFilter = {}
  ) => {
    const config = {
      url: URLS.performBulkAccountOperation,
      method: "POST",
      data: {
        type: "DELETE_ACCOUNT",
        totalCount,
        filter: {
          // Same "select all" scoping as bulkStageChange above - without it, a filtered
          // "select all" delete would attempt every zero-contact account on the team,
          // not just the ones in the current filtered view.
          ...(allAccountsSelectedInView
            ? { accountPayload: searchFilter }
            : { accountIds })
        }
      }
    };
    return await makeApi(config);
  };
}

const accountBulkActionsState = new AccountBulkActionsState();
export { accountBulkActionsState };
